import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssueDownloadUrlInput,
  CreateIssueDownloadUrlResponse,
  QueryCreateLostAndFoundIssueDocumentDownloadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateLostAndFoundIssueDocumentDownloadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssueDownloadUrlInput]?: CreateIssueDownloadUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse>;
}

// SearchLostAndFoundIssueDocument Service
export const {
  createLostAndFoundIssueDocumentDownloadUrl,
  recreateLostAndFoundIssueDocumentDownloadUrl,
  useCreateLostAndFoundIssueDocumentDownloadUrl,
} = ((): {
  createLostAndFoundIssueDocumentDownloadUrl: ServiceMethod;
  recreateLostAndFoundIssueDocumentDownloadUrl: ServiceMethod;
  useCreateLostAndFoundIssueDocumentDownloadUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(CreateLostAndFoundIssueDocumentDownloadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssueDownloadUrlInput, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse> => {
        const args: QueryCreateLostAndFoundIssueDocumentDownloadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createLostAndFoundIssueDocumentDownloadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createLostAndFoundIssueDocumentDownloadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createLostAndFoundIssueDocumentDownloadUrl: fetch,
    recreateLostAndFoundIssueDocumentDownloadUrl: refetch,
    useCreateLostAndFoundIssueDocumentDownloadUrl: useService,
  };
})();
